import { default as store, persistor } from "./store";

export { persistor };
export default store;
